<template >
  <b-card v-bind:key="board.id"
          bg-variant="light"
          :header-bg-variant="headerBg"
          header-text-variant="white"
          :header="board.name"
          class="mb-3">
    <p class="card-text">
      {{ board.description }}
    </p>
    <router-link :to="{name: 'Board', params: { id: board.id } }"><b-button variant="secondary">View board</b-button></router-link>
  </b-card>
</template>

<script>
export default {
  name: 'BoardCard',
  props: {
    board: Object
  },
  data () {
    return {
      headerBg: ''
    }
  },
  created () {
    this.setHeaderBg()
  },
  methods: {
    setHeaderBg () {
      var bg
      switch (this.board.privacy_viewability) {
        case 'board_members':
          bg = 'info'
          break
        case 'single_user':
          bg = 'warning'
          break
        default:
          bg = 'primary'
      }
      this.headerBg = bg
    }
  }
}
</script>

<style scoped >
</style>



// WEBPACK FOOTER //
// src/components/BoardCard.vue